module.exports = __webpack_public_path__ + "static/media/ic-phone.b88a30c5.svg";